<script>
import { mapActions } from 'vuex';
import { useAlert } from 'dashboard/composables';
import DeleteConfirmationModal from '../../../../branches/components/deleteConfirmationModal.vue';

export default{
  name: "BatchSelectActions",
  components: {
    DeleteConfirmationModal
  },
  props: {
    selectedChunkIds: {
      type: Array,
    }
  },
  data(){
    return{
      isDeleting: false,
      isEnabling: false,
      isDisabling: false,
      isDeleteLoading: false,
    }
  },
  methods: {
    ...mapActions('dify', ['enableChunk', 'disableChunk', 'deleteChunk']),
    async enable(){
      try{
        this.isEnabling = true;
        await this.enableChunk({ datasetId: this.$route.params.id, documentId: this.$route.params.documentId, ids: this.selectedChunkIds })
        useAlert('Chunks enabled');
        this.$emit('refresh');
      }catch(err){
        console.error(err);
      }finally{
        this.isEnabling = false;
      }
    },
    async disable(){
      try{
        this.isDisabling = true;
        await this.disableChunk({ datasetId: this.$route.params.id, documentId: this.$route.params.documentId, ids: this.selectedChunkIds })
        useAlert('Chunks disabled');
        this.$emit('refresh');
      }catch(err){
        console.error(err);
      }finally{
        this.isDisabling = false;
      }
    },
    async handleDelete(){
        try{
            this.isDeleteLoading = true;
            await this.deleteChunk({ datasetId: this.$route.params.id, documentId: this.$route.params.documentId, ids: this.selectedChunkIds });
            useAlert('Chunk deleted');
            this.isDeleting = false;
            this.$emit('refresh');
        }catch(err){
            console.error(err);
        }finally{
            this.isDeleteLoading = false;
        }
    }
  }
}
</script>

<template>
 <div>
  <!-- Delete Confirmation Modal -->
  <div
    class="fixed inset-0 flex items-center justify-center bg-slate-900/50 dark:bg-slate-800/70 h-[100vh] w-[100vw] z-50"
    v-if="isDeleting"
  >
    <DeleteConfirmationModal
      :deleteName="selectedChunkIds.length > 1 ? $t('KNOWLEDGE.BATCH_SELECT_ACTIONS.SELECTED_CHUNKS') :  $t('KNOWLEDGE.BATCH_SELECT_ACTIONS.THIS_CHUNK')"
      :is-deleting="isDeleteLoading"
      @confirm-delete="handleDelete"
      @close="isDeleting = false"
    />
  </div>

  <!-- Responsive Action Bar -->
  <div class="fixed bottom-0 left-0 right-0 md:bottom-4 md:left-1/2 md:transform md:-translate-x-1/2 flex flex-wrap gap-2 bg-white dark:bg-slate-700 rounded-t-lg md:rounded-md py-2 px-4 items-center justify-center shadow-lg z-50 border-t border-gray-200 dark:border-slate-600 md:border-none md:w-auto w-full">
    <!-- Selected Count -->
    <p class="mb-0 whitespace-nowrap text-woot-500 dark:text-woot-400 font-semibold flex items-center gap-2">
      <span class="p-1 md:p-2 rounded-md bg-woot-500 text-white text-sm md:text-base">
        {{ selectedChunkIds.length }}
      </span>
      <span class="hidden sm:inline">{{ $t('KNOWLEDGE.BATCH_SELECT_ACTIONS.SELECTED') }}</span>
    </p>

    <!-- Buttons - will wrap on small screens -->
    <div class="flex flex-wrap justify-center gap-1 md:gap-2">
      <woot-button
        variant="clear"
        icon="checkmark-circle"
        size="small"
        :disabled="isEnabling || isDisabling"
        @click="enable"
        class="text-xs md:text-sm"
      >
        <span class="hidden xs:inline">{{ $t('KNOWLEDGE.BATCH_SELECT_ACTIONS.ENABLE') }}</span>
      </woot-button>

      <woot-button
        variant="clear"
        icon="dismiss-circle"
        size="small"
        :disabled="isEnabling || isDisabling"
        @click="disable"
        class="text-xs md:text-sm"
      >
        <span class="hidden xs:inline">{{ $t('KNOWLEDGE.BATCH_SELECT_ACTIONS.DISABLE') }}</span>
      </woot-button>

      <woot-button
        variant="clear"
        icon="delete"
        color-scheme="alert"
        size="small"
        @click="isDeleting = true"
        class="text-xs md:text-sm"
      >
        <span class="hidden xs:inline">{{ $t('KNOWLEDGE.DELETE_BUTTON') }}</span>
      </woot-button>
      
      <woot-button 
        variant="clear" 
        color-scheme="secondary" 
        size="small"
        @click="$emit('cancelBatchSelect')"
        class="text-xs md:text-sm"
      >
        {{ $t('KNOWLEDGE.CANCEL_BUTTON') }}
      </woot-button>
    </div>
  </div>
</div>
</template>